import axios from 'axios';

export default {
  getCombinations({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/combination/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertCombinations', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addCombination({ commit, state }, { combination, event }) {
    return new Promise((resolve, reject) => {
      commit('addCombinationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/combination/add`,
        params: combination,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addCombinationRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addCombinationRequestError', err);
          reject(err);
        });
    });
  },
  editCombination({ commit, state }, { combination, event }) {
    return new Promise((resolve, reject) => {
      commit('editCombinationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/combination/edit`,
        params: combination,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editCombinationRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editCombinationRequestError', err);
          reject(err);
        });
    });
  },
  deleteCombination({ commit, state }, combinationId) {
    return new Promise((resolve, reject) => {
      commit('deleteCombinationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/combination/destroy`,
        params: { id: combinationId },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteCombinationRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteCombinationRequestError', err);
          reject(err);
        });
    });
  }
};
